import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-add-button',
  templateUrl: './add-button.component.html',
  styleUrls: ['./add-button.component.scss']
})
export class AddButtonComponent implements OnInit {

  @Input() title: { type: string, required: true; }
  @Input() icon: { type: string, required: false; }
  @Input() color: { type: string, required: false; }
  @Input() formData: any = {}
  @Input() disabled = false;
  @Output() createFunction = new EventEmitter();



  constructor() { }

  ngOnInit(): void {
  }

  create(formData) {
    // this.formData.name="Test"

    this.createFunction.emit(formData)
  }
}
